import { PropsWithChildren, createContext, useContext, useMemo } from 'react'

interface FormSectionValue {
  disabled?: boolean
}

const formSectionContext = createContext<FormSectionValue>({
  disabled: undefined
})

interface Props {
  disabled?: boolean
}

export function FormSection({ children, disabled }: PropsWithChildren<Props>) {
  const value = useMemo(() => ({ disabled }), [disabled])

  return <formSectionContext.Provider value={value}>{children}</formSectionContext.Provider>
}

export function useFormSection(): FormSectionValue {
  return useContext(formSectionContext)
}
